module.exports = __webpack_public_path__ + "static/media/HCMM631.bb7de3fa.jpg";